import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { RdsBadgeModule, RdsButtonModule } from '@rds/angular-components';
import { RdsMinimalBadgeColor } from '@rds/core';
import { FaroActionDirective } from '../../../directives/faro-action.directive';

@Component({
  selector: 'inexp-offering-card',
  imports: [
    RouterModule,
    RdsButtonModule,
    RdsBadgeModule,
    FaroActionDirective,
  ],
  templateUrl: './offering-card.component.html',
  styleUrl: './offering-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferingCardComponent {
  displayName = input<string>();
  offeringImage = input<string>();
  description = input<string>();
  slug = input<string>();

  /** Approval status shown as a badge; omitted where it is not known. */
  approvalStatus = input<string>();

  /**
   * Pre-rendered description markup, used by search to keep the matched
   * extract's emphasis. Falls back to `description` when absent.
   */
  descriptionHtml = input<string>();

  /**
   * Green for the statuses that mean "go ahead", red for the one that does not,
   * neutral for anything unrecognised — a status we cannot interpret should
   * read as information, not as approval.
   *
   * These are the `minimal` badge's colours, which are a different vocabulary
   * from the default badge's: `success`/`error`/`warning` have no minimal
   * variant, so RDS emits no class for them and the badge falls back to grey.
   */
  readonly statusColor = computed<RdsMinimalBadgeColor>(() => {
    const status = (this.approvalStatus() ?? '').toLowerCase();
    if (status.includes('not approved') || status.includes('unsupported')) {
      return 'red';
    }
    if (status.includes('conditional')) {
      return 'yellow';
    }
    if (status.includes('approved') || status.includes('preferred')) {
      return 'green';
    }
    return 'neutral';
  });
}
